import './PageNotFound.css';
import React from "react";


function PageNotFound() {

    return (
        <div className="feedbackScreen">
            <h1> page not found! </h1>
            <a href="/">
                <p className="backToHomeText"> go back to home</p>
            </a>
        </div>
    )
}

export default PageNotFound;